/*
 * collection.js — Kategorie-/Collection-Seite (WP 2.2).
 * Enhancement über die Section Rendering API; ohne JS bleibt alles per echten ?-Links nutzbar.
 *
 *  - Load-More: hängt die nächste Produktseite an [data-collection-grid] an, aktualisiert
 *    Progress-Text + Fortschrittsbalken + Button-Ziel (role=status für Count).
 *  - Filter/Sort live: fetch auf URL + section_id, ersetzt [data-collection-grid] und
 *    [data-collection-results]; History-Push (zurück-Button funktioniert).
 *  - Mobile Filter-Sheet: öffnen/schließen über window.Homedia.overlay.
 *
 * IIFE-guarded (window.HomediaCollection einmalig). Mehrere Sektionen je Seite werden unterstützt
 * (Delegation auf document + Lookup des nächsten [data-collection-root]).
 */
(function () {
  'use strict';
  if (window.HomediaCollection) return;
  window.HomediaCollection = true;

  var GRID = '[data-collection-grid]';
  var RESULTS = '[data-collection-results]';

  function rootOf(el) { return el ? el.closest('[data-collection-root]') : null; }

  function sectionId(root) {
    try {
      var cfg = root.querySelector('[data-collection-config]');
      if (cfg) return (JSON.parse(cfg.textContent) || {}).sectionId;
    } catch (e) {}
    return null;
  }

  // Hängt section_id an eine URL an; das page-Handling liegt bei den Aufrufern.
  function withSection(url, id) {
    var u = new URL(url, window.location.origin);
    if (id) u.searchParams.set('section_id', id);
    return u.toString();
  }

  function fetchSection(url) {
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('section fetch failed');
        return r.text();
      })
      .then(function (html) {
        return new DOMParser().parseFromString(html, 'text/html');
      });
  }

  function setBusy(root, busy) {
    var grid = root.querySelector(GRID);
    if (grid) grid.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  // ---------- Filter / Sort: ganze Grid-Region + Count ersetzen ----------
  function navigate(root, url, push, scrollSel) {
    var id = sectionId(root);
    // Sequenz-Guard: bei schnellen Filterwechseln darf nur die NEUESTE Response
    // Grid/URL setzen (out-of-order Responses würden veralteten Stand rendern).
    var seq = (root.__hmNavSeq = (root.__hmNavSeq || 0) + 1);
    setBusy(root, true);
    fetchSection(withSection(url, id)).then(function (doc) {
      if (seq !== root.__hmNavSeq) return; // überholt: neuerer navigate() läuft bereits
      var freshGrid = doc.querySelector(GRID);
      var curGrid = root.querySelector(GRID);
      if (freshGrid && curGrid) curGrid.innerHTML = freshGrid.innerHTML;

      var freshResults = doc.querySelector(RESULTS);
      var curResults = root.querySelector(RESULTS);
      if (freshResults && curResults) curResults.innerHTML = freshResults.innerHTML;

      // Filter-Sidebar + Chips + Compat-Banner spiegeln (Counts/aktive Werte ändern sich mit der Auswahl)
      ['[data-collection-filters]', '[data-collection-chips]', '[data-collection-compat]'].forEach(function (sel) {
        var fresh = doc.querySelector(sel);
        var cur = root.querySelector(sel);
        if (fresh && cur) {
          cur.innerHTML = fresh.innerHTML;
        } else if (!fresh && cur && sel === '[data-collection-chips]') {
          cur.innerHTML = '';
        }
      });

      if (push) {
        try { window.history.pushState({ hmCollection: true }, '', url); } catch (e) {}
      }
      setBusy(root, false);
      // Scroll sanft zum Ziel: Filter/Sort → Grid; Compat-Banner-Klick → Banner bleibt oben sichtbar.
      // A11y: explizites behavior:'smooth' übersteuert die CSS-Property — Reduce-Wunsch selbst prüfen (F084).
      var target = root.querySelector(scrollSel || '.hm-collection__content');
      if (target && target.scrollIntoView) {
        // Geteilter Helfer aus overlay.js; Fallback-matchMedia, falls overlay.js (noch) fehlt.
        var reduce = (window.Homedia && window.Homedia.overlay && window.Homedia.overlay.reducedMotion)
          ? window.Homedia.overlay.reducedMotion()
          : (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        try { target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); } catch (e) {}
      }
    }).catch(function () {
      if (seq !== root.__hmNavSeq) return; // überholter Request → nicht hart zur alten URL navigieren
      // Fallback: harte Navigation
      window.location.href = url;
    });
  }

  // ---------- Load-More: nächste Seite anhängen ----------
  function loadMore(root, btn) {
    var url = btn.getAttribute('href');
    if (!url) return;
    var id = sectionId(root);
    var wrap = btn.closest('[data-collection-loadmore]');
    if (wrap) wrap.setAttribute('data-loading', 'true');

    fetchSection(withSection(url, id)).then(function (doc) {
      var grid = root.querySelector('.hm-product-grid');
      var freshGrid = doc.querySelector('.hm-product-grid');
      if (grid && freshGrid) {
        var frag = document.createDocumentFragment();
        Array.prototype.slice.call(freshGrid.children).forEach(function (c) { frag.appendChild(c); });
        grid.appendChild(frag);
      }

      // Progress / Bar / Button aus dem frischen Load-More-Block übernehmen
      var progress = root.querySelector('[data-loadmore-progress]');
      var freshProgress = doc.querySelector('[data-loadmore-progress]');
      if (progress && freshProgress) progress.innerHTML = freshProgress.innerHTML;
      var bar = root.querySelector('[data-loadmore-bar]');
      var freshBar = doc.querySelector('[data-loadmore-bar]');
      if (bar && freshBar) bar.style.width = freshBar.style.width;

      var freshBtn = doc.querySelector('[data-loadmore-btn]');
      if (freshBtn) {
        btn.setAttribute('href', freshBtn.getAttribute('href'));
      } else {
        // keine weitere Seite → Button entfernen
        if (btn.parentNode) btn.parentNode.removeChild(btn);
      }
      if (wrap) wrap.removeAttribute('data-loading');

      try { window.history.replaceState(window.history.state, '', url); } catch (e) {}
    }).catch(function () {
      if (wrap) wrap.removeAttribute('data-loading');
      window.location.href = url;
    });
  }

  // ---------- Delegierte Events ----------
  document.addEventListener('click', function (e) {
    // Load-More
    var more = e.target.closest('[data-loadmore-btn]');
    if (more) {
      var rootM = rootOf(more);
      if (rootM) { e.preventDefault(); loadMore(rootM, more); return; }
    }

    // Filter-Wert-Links (Compat-Banner-Buttons, aktive Chips, „Alle entfernen", Reset)
    var link = e.target.closest('[data-chip-remove], [data-filter-clear], .hm-compat-banner__opt');
    if (link && link.tagName === 'A') {
      var rootL = rootOf(link);
      if (rootL) {
        e.preventDefault();
        // Compat-Banner-Klick: zum Banner scrollen (bleibt oben sichtbar), #-Anker fürs AJAX entfernen.
        var compat = link.closest('.hm-compat-banner');
        var href = link.getAttribute('href');
        if (compat) href = href.split('#')[0];
        navigate(rootL, href, true, compat ? '.hm-compat-banner' : null);
        return;
      }
    }
  });

  // Sort-Dropdown
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-collection-sort]');
    if (sel) {
      var root = rootOf(sel);
      if (!root) return;
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      navigate(root, u.toString(), true);
      return;
    }

    // Filter-Checkbox live (Desktop). Mobile-Sheet nutzt den Submit-Button.
    var cb = e.target.closest('[data-filter-input]');
    if (cb && window.innerWidth > 900) {
      var rootC = rootOf(cb);
      var form = cb.closest('[data-collection-filter-form]');
      if (rootC && form) {
        var fd = new FormData(form);
        var qs = new URLSearchParams();
        fd.forEach(function (val, key) { if (val !== '') qs.append(key, val); });
        var base = form.getAttribute('action') || window.location.pathname;
        navigate(rootC, base + (qs.toString() ? '?' + qs.toString() : ''), true);
      }
    }
  });

  // Filter-Form-Submit (Mobile-Sheet „X Produkte zeigen" + No-JS-Fallback-Submit)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-collection-filter-form]');
    if (!form) return;
    var root = rootOf(form);
    if (!root) return;
    e.preventDefault();
    var fd = new FormData(form);
    var qs = new URLSearchParams();
    fd.forEach(function (val, key) { if (val !== '') qs.append(key, val); });
    var base = form.getAttribute('action') || window.location.pathname;
    navigate(root, base + (qs.toString() ? '?' + qs.toString() : ''), true);
    // Mobile-Sheet nach Anwenden schließen
    var panel = root.querySelector('[data-collection-filters]');
    if (panel && window.Homedia && window.Homedia.overlay && window.Homedia.overlay.isOpen(panel)) {
      window.Homedia.overlay.close(panel);
    }
  });

  // Browser-Zurück
  window.addEventListener('popstate', function () {
    var root = document.querySelector('[data-collection-root]');
    if (root) navigate(root, window.location.href, false);
  });

  // ---------- Mobile-Filter-Sheet: Scrim mit dem Panel ein-/ausblenden ----------
  // overlay.js verwaltet das Panel + dispatcht bubbelnde overlay:open/close-Events.
  document.addEventListener('overlay:open', function (e) {
    var panel = e.target;
    if (!panel || !panel.matches || !panel.matches('[data-collection-filters]')) return;
    var root = rootOf(panel);
    var scrim = root && root.querySelector('[data-filter-scrim]');
    if (scrim) { scrim.hidden = false; scrim.setAttribute('data-state', 'open'); }
  });
  document.addEventListener('overlay:close', function (e) {
    var panel = e.target;
    if (!panel || !panel.matches || !panel.matches('[data-collection-filters]')) return;
    var root = rootOf(panel);
    var scrim = root && root.querySelector('[data-filter-scrim]');
    if (scrim) { scrim.removeAttribute('data-state'); scrim.hidden = true; }
  });
})();
